/**
 * FAQ data for Home page
 */

export const getFaqs = (t) => [
  {
    id: "faq-1",
    question: t("home.faq.question1.q"),
    answer: t("home.faq.question1.a"),
  },
  {
    id: "faq-2",
    question: t("home.faq.question2.q"),
    answer: t("home.faq.question2.a"),
  },
  {
    id: "faq-3",
    question: t("home.faq.question3.q"),
    answer: t("home.faq.question3.a"),
  },
  {
    id: "faq-4",
    question: t("home.faq.question4.q"),
    answer: t("home.faq.question4.a"),
  },
  {
    id: "faq-5",
    question: t("home.faq.question5.q"),
    answer: t("home.faq.question5.a"),
  },
  {
    id: "faq-6",
    question: t("home.faq.question6.q"),
    answer: t("home.faq.question6.a"),
  },
];
